// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"744ac746","729":"5013e0f0","770":"a0f9304a","918":"0b83e41f"}[chunkId] + ".chunk.js";
};